export type Sector = "ONE" | "TWO" | "THREE" | "FOUR";

export type MouthType = "FULL" | "SPLIT";

export const MouthTypes = ["FULL", "SPLIT"] as const;

export const Sectors = ["ONE", "TWO", "THREE", "FOUR"] as const;
